import { render, staticRenderFns } from "./View.vue?vue&type=template&id=de8f2612&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=de8f2612&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8f2612",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de8f2612')) {
      api.createRecord('de8f2612', component.options)
    } else {
      api.reload('de8f2612', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=de8f2612&scoped=true", function () {
      api.rerender('de8f2612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialists/management/components/supervision-tab/View.vue"
export default component.exports